import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function Pricing() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    api.get("/billing/plans").then((r) => setPlans(r.data));
  }, []);

  const fmt = (n) => "₹" + n.toLocaleString("en-IN");

  return (
    <div className="min-h-screen bg-[#05060F] text-white grid-bg p-6 lg:p-12">
      <div className="max-w-7xl mx-auto">
        <Link to="/" data-testid="pricing-back-home" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white mb-10">
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="text-center mb-14">
          <div className="text-xs uppercase tracking-[0.25em] text-indigo-400 mb-4">Pricing — INR</div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
            Pick a plan. <br />Hire the AI.
          </h1>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">
            All plans billed monthly. GST extra. Manual payment via NEFT/UPI now — Razorpay & Stripe launching soon.
          </p>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-5 gap-6">
          {plans.map((p, i) => {
            const highlight = p.id === "professional";
            return (
              <div
                key={p.id}
                className={`glass rounded-2xl p-7 flex flex-col ${highlight ? "border-indigo-500/40 bg-gradient-to-b from-indigo-500/[0.08] to-transparent glow-orange" : ""}`}
              >
                {highlight && (
                  <div className="text-[10px] uppercase tracking-[0.25em] brand-gradient-text font-bold mb-3">Most Popular</div>
                )}
                <h3 className="font-heading font-black text-xl">{p.name}</h3>
                <p className="text-xs text-white/50 mt-1">{p.blurb}</p>
                <div className="mt-5 flex items-baseline gap-1">
                  <span className="font-heading font-black text-4xl">{fmt(p.price_inr)}</span>
                  <span className="text-white/40 text-xs">/mo</span>
                </div>
                <ul className="mt-6 space-y-2.5 text-sm flex-1">
                  <li className="flex items-start gap-2 text-white/70"><Check className="h-4 w-4 text-indigo-400 shrink-0 mt-1" /> {p.limits.ai_credits.toLocaleString("en-IN")} AI credits/mo</li>
                  <li className="flex items-start gap-2 text-white/70"><Check className="h-4 w-4 text-indigo-400 shrink-0 mt-1" /> {p.limits.monthly_posts >= 9999 ? "Unlimited" : p.limits.monthly_posts} social posts/mo</li>
                  <li className="flex items-start gap-2 text-white/70"><Check className="h-4 w-4 text-indigo-400 shrink-0 mt-1" /> {p.limits.logo_credits} logos · {p.limits.video_credits} videos</li>
                  <li className="flex items-start gap-2 text-white/70"><Check className="h-4 w-4 text-indigo-400 shrink-0 mt-1" /> {p.limits.websites} websites · {p.limits.social_accounts} channels</li>
                  <li className="flex items-start gap-2 text-white/70"><Check className="h-4 w-4 text-indigo-400 shrink-0 mt-1" /> {p.limits.auto_reply_limit.toLocaleString("en-IN")} AI replies/mo</li>
                  <li className="flex items-start gap-2 text-white/70"><Check className="h-4 w-4 text-indigo-400 shrink-0 mt-1" /> {p.limits.support_level}</li>
                </ul>
                <Link
                  to="/register"
                  data-testid={`pricing-page-cta-${p.id}`}
                  className={`mt-7 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg text-sm font-semibold ${highlight ? "brand-gradient hover:opacity-90" : "glass hover:bg-white/5"}`}
                >
                  Choose {p.name} <ArrowUpRight className="h-4 w-4" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
